import { FC, useEffect } from 'react';
import { Fade, Paper, Box, Typography, Button } from '@mui/material';
import Banner from '@acorn-portal/shared/src/components/banner/MotorcadeLanderBanner';
import { useNavigate } from 'react-router';
import Home from '@mui/icons-material/Home';
import { useAppDispatch } from '@acorn-portal/shared/src/hooks/reduxHook';
import { clearMidTermAdjustmentDetails } from '@acorn-portal/shared/src/store/midTermAdjustment.slice';
import { resetApiMTA } from '@acorn-portal/shared/src/store/midTermAdjustmentAPI.sclice';

const MtaReferralPage: FC = () => {
	const navigate = useNavigate();
	const dispatch = useAppDispatch();

	useEffect(() => {
		dispatch(clearMidTermAdjustmentDetails());
		dispatch(resetApiMTA());
	}, [dispatch]);

	return (
		<Paper
			elevation={1}
			sx={{
				borderRadius: '8px',
			}}
		>
			<Fade in>
				<Box>
					<Banner text='We’re reviewing your quote' />
					<Box
						sx={{
							display: 'flex',
							justifyContent: 'center',
							flexDirection: 'column',
							alignItems: 'center',
							textAlign: 'center',
							px: 2,
							'& > *': { mb: 3 },
						}}
					>
						<Box
							sx={(theme) => ({
								mt: 4,
								mx: '10%',
								'& > *': { mb: 3 },
								[theme.breakpoints.down('md')]: {
									mx: 'unset',
								},
							})}
						>
							<Box>
								<Typography variant='h6' fontWeight='lighter'>
									Thank you for requesting a quote with Motorcade today for a change on your policy. Unfortunately, we
									are unable to progress with the proposed change at this time.
								</Typography>
							</Box>
							<Typography>
								Please contact us using the webchat facility on our{' '}
								<a href='https://motorcade.co.uk/' target='_blank' rel='noreferrer'>
									main website
								</a>{' '}
								if you wish to discuss your change
							</Typography>
							<Typography>
								Thank you for your interest in Motorcade insurance - we look forward to speaking to you soon.
							</Typography>
						</Box>
						<Button
							startIcon={<Home />}
							size='large'
							variant='contained'
							onClick={() => {
								navigate('/portal/home');
								return null;
							}}
						>
							Return to homepage
						</Button>
						<Box sx={{ margin: 2 }} />
					</Box>
				</Box>
			</Fade>
		</Paper>
	);
};

export default MtaReferralPage;
